import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { usePosthogEvents } from '@terminal/services/tracking/posthog/use-posthog-events/usePosthogEvents';
import { ReportingDates } from '@terminal/widgets/earnings/components/reporting-dates/ReportingDates';
import { getReportingPeriodLabel } from '@terminal/widgets/earnings/components/reporting-dates/utils';

import {
  type CalendarQuarterPeriod,
  fromReportingDatesPeriod,
  toReportingDatesPeriod,
} from './utils';

export interface ThemeEarningsReportingDatesProps {
  reportingPeriods: CalendarQuarterPeriod[];
  activeReportingPeriod?: CalendarQuarterPeriod;
  onActiveReportingPeriodChange: (
    reportingPeriod: CalendarQuarterPeriod
  ) => void;
}

export const ThemeEarningsReportingDates = ({
  reportingPeriods,
  activeReportingPeriod,
  onActiveReportingPeriodChange,
}: ThemeEarningsReportingDatesProps) => {
  const { trackThemeEarningsPeriodSelected } = usePosthogEvents();

  if (!activeReportingPeriod) {
    return null;
  }

  return (
    <ReportingDates
      reportingPeriods={reportingPeriods.map(toReportingDatesPeriod)}
      activeReportingPeriod={toReportingDatesPeriod(activeReportingPeriod)}
      onActiveReportingPeriodChange={period => {
        trackThemeEarningsPeriodSelected(
          POSTHOG_TRACKING_SOURCES.THEME_OVERVIEW,
          getReportingPeriodLabel(period)
        );
        onActiveReportingPeriodChange(fromReportingDatesPeriod(period));
      }}
    />
  );
};
